import React from 'react';
import { titleize } from 'inflection';

import styles from './fundHoldingCardStyles';

import ReturnValue from 'buyside/components/presentation/ReturnValue/returnValue';

import formatTimeframe from 'buyside/util/formatTimeframe';

const FundHoldingCard = ({ holding }) => {
  const {
    percentOfPortfolio,
    entityName,
    primarySymbol,
    assetClass,
    realizedReturn,
    expectedReturn,
    averageCost,
    action,
    priceTarget,
    timeframe
  } = holding;
  const items = [
    { label: 'Asset Class', value: assetClass },
    { label: 'Return to Date', value: <ReturnValue value={realizedReturn} /> },
    { label: 'Expected Return', value: <strong>{expectedReturn}%</strong> },
    { label: 'Avg. Cost', value: averageCost },
    { label: 'Action', value: action },
    { label: 'Target Price', value: priceTarget },
    { label: 'Timeframe', value: formatTimeframe(timeframe) }
  ];
  return (
    <div>
      <h4 className={styles.fundHoldingCardHeader}>
        <span>
          {percentOfPortfolio}% - {titleize(entityName || '')}
        </span>
        <span className={styles.fundHoldingCardSymbol}>({primarySymbol})</span>
      </h4>
      <div>
        {items.map((item, idx) => (
          <div key={idx} className={styles.fundHoldingCardRow}>
            <span>{item.label}:</span>
            <span>{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FundHoldingCard;
